export const HTTP_STEP_UP_REQUIRED = 428
export const HTTP_STEP_UP_ERROR = 417
